import { API, generic } from "api"

export default class PlansService {
  static index = async ({ pageState }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_GUESTS_CM_PLANS_INDEX_STATUS",
      stateDataKey: ["plans"],
      stateErrorKey: ["plansErrors"],
      apiEndpoint: API.guests.cm.plans.index,
      apiUrlReplacements: {},
      apiData: {},
      errorMessage: "Plans could not be fetched",
    })
  }
}
